import { render, staticRenderFns } from "./WaypointSortPreviewTransportations.vue?vue&type=template&id=10fa5099"
import script from "./WaypointSortPreviewTransportations.vue?vue&type=script&lang=ts&setup=true"
export * from "./WaypointSortPreviewTransportations.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports